import styled from 'styled-components'

const Badge = styled.img`
  margin-right: 20px;
  margin-bottom: 5px;
`
const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-right: 10px;
`

// eslint-disable-next-line import/prefer-default-export
export { Badge, BadgeWrapper }
